module.exports = __webpack_public_path__ + "img/text.4ca298bd.png";